import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CheckoutConfirmation",
    component: () =>
        __SERVER__ ? require("./checkout-confirmation-view") : import("./checkout-confirmation-view")
});

export default definition;
